import { render, staticRenderFns } from "./computer.vue?vue&type=template&id=1accd37b&scoped=true"
import script from "./computer.vue?vue&type=script&lang=js"
export * from "./computer.vue?vue&type=script&lang=js"
import style0 from "./computer.vue?vue&type=style&index=0&id=1accd37b&prod&lang=scss&scoped=true"
import style1 from "./computer.vue?vue&type=style&index=1&id=1accd37b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1accd37b",
  null
  
)

export default component.exports